<app-aps-create-person-client-side-form
	[(firstName)]="client.firstName"
	[(middleName)]="client.middleNames"
	[(lastName)]="client.lastName"
	[(email)]="client.email"
	[(title)]="client.title"
	[(phone)]="client.phone"
	[(gender)]="client.gender"
	[(title)]="client.title"
	[dateOfBirth]="client?.dateOfBirth"
	[primary]="primaryContact"
	[selectedRepresentation]="client?.representation"
	[showPrimaryClientOption]="showPrimaryClientOption"
	[showIDsOption]="showIDsOption"
	[showRepresentationOption]="showRepresentationOption"
	(onCreate)="_onCreate($event)"
	(onCancel)="_onCancel()"
>
</app-aps-create-person-client-side-form>
